window.CityMessenger.isIE = /*@cc_on!@*/false || !!document.documentMode;
